import { atom } from "jotai";

import {
  currentBookingAtom,
  currentSessionUserClientIdAtom,
  originalBookingOwnerClientIdAtom,
  pendingRequestGroupAtom,
} from "../../stores";

export const requestGroupControlsAtom = atom((get) => {
  const booking = get(currentBookingAtom);
  const ownerId = get(originalBookingOwnerClientIdAtom);
  const groupCount = booking
    ? Math.max(0, ...booking.rounds.map((round) => round.bookingIndex ?? 0)) + 1
    : 0;
  const canEdit = Boolean(
    booking?.isRequestBooking &&
      booking.type === "Golf" &&
      !booking.isAlreadyPaid &&
      ownerId &&
      ownerId === get(currentSessionUserClientIdAtom) &&
      !get(pendingRequestGroupAtom)
  );

  return {
    groupCount,
    canAdd: canEdit && groupCount < (booking?.maxRequestGroupCount ?? 1),
    canRemove: canEdit && groupCount > 1,
  };
});
